import { CuratorsList } from "./customTypes";

type RequestOptions = Pick<RequestInit, "signal">;

export class CustomLemmyHttp {
    private baseUrl: string;
    private headers?: { [key: string]: string };
    private fetchFunction: typeof fetch;
  
    constructor(
      baseUrl: string,
      options?: { fetchFunction?: typeof fetch; headers?: { [key: string]: string } }
    ) {
      this.baseUrl = baseUrl;
      this.headers = options?.headers ?? {};
      this.fetchFunction = options?.fetchFunction ?? fetch;
    }
  
    async getCurators(options?: RequestOptions): Promise<CuratorsList> {
      const response = await this.fetchFunction(`${this.baseUrl}/api/v3/user/list`, {
        method: "GET",
        headers: {
          ...this.headers,
          "Content-Type": "application/json",
        },
        signal: options?.signal,
      });
  
      if (!response.ok) {
        throw new Error(`Failed to fetch curators: ${response.statusText}`);
      }

      const data = await response.json();
      
      return { list: data.list ?? [] };
    }

    getBlueskyOAuth(options?: RequestOptions): void {
      window.location.href = `${this.baseUrl}/oauth/login/bluesky`;
      // const response = await this.fetchFunction(`${this.baseUrl}/oauth/login/bluesky`, {
      //   method: "GET",
      //   headers: {
      //     // ...this.headers,
      //     "Content-Type": "application/json",
      //   },
      //   signal: options?.signal,
      // });
  
      // if (!response.ok) {
      //   throw new Error(`Failed to fetch Bluesky OAuth: ${response.statusText}`);
      // }

      
      // const data = await response.json();
      
      // return data;
    }

    async validateToken(options?: RequestOptions) {
      const response = await this.fetchFunction(`${this.baseUrl}/api/v3/user/validate_token`, {
        method: "GET",
        headers: {
          ...this.headers,
          "Content-Type": "application/json",
        },
        signal: options?.signal,
      });
      
      return await response.json();
    }

    async saveUserSettings(data: Object, options?: RequestOptions) {
      const response = await this.fetchFunction(`${this.baseUrl}/api/v3/user/save_user_settings`, {
        method: "PUT",
        headers: {
          ...this.headers,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        signal: options?.signal,
      });
      
      return await response.json();
    }
  }